import type { FC, PropsWithChildren } from 'react'

import { Body } from './styles'

export const AppBody: FC<PropsWithChildren> = ({ children }) => (
  <Body>{children}</Body>
)
